import React from 'react'
import { Grid, FormControlLabel, Switch } from '@mui/material';
import { ICustomerEmail } from '../../../Interfaces/Customer/ICustomerEmail';
import { EmailInput } from '@amsanalytics/react-shared-library';

interface ICustomerEmailProps {
  email?: ICustomerEmail;
  onUpdateEmail(email: ICustomerEmail): void;
  disabled?: boolean;
}

const EmailCard: React.FC<ICustomerEmailProps> = (props) => {
  const { email } = props;

  const handleUpdate = <T extends {} | null>(value: T, fieldName: string): void => {
    if (props.email) {
      // Make a copy of value we are updating.
      const updatedEmail: ICustomerEmail = {
        ...props.email
      };
      // Update property with new value.
      updatedEmail[fieldName] = value;
      props.onUpdateEmail(updatedEmail);
    }
  }

  return (
    <>
      {email ?
        <Grid style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', margin: 5, paddingBottom: '5px' }} container spacing={1}>
          <Grid item xs={6} sm={4} style={{ marginRight: '10px', maxWidth: '500px' }}>
            <EmailInput style={{backgroundColor: 'white', width: '100%'}} disabled={props.disabled} value={email.emailAddress} fullWidth={true} onChangeValue={(val) => handleUpdate<string>(val, "emailAddress")} label="Email" />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FormControlLabel 
              control={<Switch disabled={props.disabled} checked={email.doNotEmail} onChange={(e) => handleUpdate<boolean>(e.currentTarget.checked, "doNotEmail")} />}
              label="Do not Email"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FormControlLabel
              control={<Switch disabled={props.disabled} checked={email.isPreferred} onChange={(e) => handleUpdate<boolean>(e.currentTarget.checked, "isPreferred")} />}
              label="Preferred" />
          </Grid>
          <Grid item xs={6} sm={2} />
        </Grid>
        : null}
    </>)
}

export default EmailCard;
